import {
  Dialog,
  DialogTitle,
  Divider,
  ListItemIcon,
  MenuItem,
  makeStyles,
} from "@material-ui/core";
import classNames from "classnames";
import { forwardRef, useCallback, useState } from "react";
import { stopPropagationForTab } from "../../common/util/stopPropagationForTab";
import { SupervisedUserCircle } from "@material-ui/icons";
import { SwitchToCustomerForm } from "./SwitchToCustomerForm";

interface Props {
  isOverridden: boolean;
  onClick?: any;
  className?: string;
}

const useStyles = makeStyles(
  (theme) => ({
    root: {
      color: theme.palette.text.secondary,
    },
    active: {
      color: theme.palette.text.primary,
    },
    icon: { minWidth: theme.spacing(5) },
  }),
  { name: "RaMenuItemLink" }
);

export const LoginAsCustomerCommand = forwardRef<HTMLLIElement, Props>(
  ({ onClick, className, isOverridden, ...rest }: Props, ref) => {
    const classes = useStyles();
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const handleMenuClick = useCallback(() => {
      setDialogOpen(true);
    }, []);

    const handleClose = useCallback(() => {
      setDialogOpen(false);
      onClick();
    }, [onClick]);

    const handleSuccess = useCallback(() => {
      handleClose();
      window.location.href = "/";
    }, [handleClose]);

    return (
      <>
        <MenuItem
          className={classNames(classes.root, className)}
          ref={ref}
          tabIndex={0}
          {...rest}
          onClick={handleMenuClick}
        >
          <ListItemIcon className={classes.icon}>
            <SupervisedUserCircle
              titleAccess={
                isOverridden ? "View as master admin" : "View as customer..."
              }
            />
          </ListItemIcon>
          {isOverridden ? "View as master admin" : "View as customer..."}
        </MenuItem>
        <Dialog
          open={dialogOpen}
          onClose={handleClose}
          maxWidth="sm"
          fullWidth
          onKeyDown={stopPropagationForTab}
        >
          <DialogTitle>
            {isOverridden ? <>View as master admin</> : <>View as customer</>}
          </DialogTitle>
          <Divider />
          <SwitchToCustomerForm
            isOverridden={isOverridden}
            onSuccess={handleSuccess}
            onFailed={handleClose}
          />
        </Dialog>
      </>
    );
  }
);
